import React from "react";
import { Tooltip } from "@mui/material";

export const TruncatedTextWithTooltip = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => {
  const textRef = React.useRef<HTMLParagraphElement | null>(null);
  const [isTruncated, setIsTruncated] = React.useState(false);

  const updateTruncation = React.useCallback(() => {
    const node = textRef.current;
    if (!node) {
      return;
    }
    setIsTruncated(node.scrollWidth > node.clientWidth);
  }, []);

  React.useLayoutEffect(() => {
    updateTruncation();
    const node = textRef.current;
    if (!node || typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const observer = new ResizeObserver(updateTruncation);
    observer.observe(node);
    return () => observer.disconnect();
  }, [text, updateTruncation]);

  return (
    <Tooltip
      title={text}
      placement="top"
      disableHoverListener={!isTruncated}
      componentsProps={{
        tooltip: {
          sx: { fontFamily: "Mulish", fontSize: "12px" },
        },
      }}
    >
      <p ref={textRef} className={className}>
        {text}
      </p>
    </Tooltip>
  );
};
